import { render, staticRenderFns } from "./AlarmItem.vue?vue&type=template&id=4a2e2e22&scoped=true&"
import script from "./AlarmItem.vue?vue&type=script&lang=js&"
export * from "./AlarmItem.vue?vue&type=script&lang=js&"
import style0 from "./AlarmItem.vue?vue&type=style&index=0&id=4a2e2e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e2e22",
  null
  
)

export default component.exports